module.exports = __webpack_public_path__ + "img/product_bg_01_en_01.af78e59.png";